export default "__VITE_ASSET__DxT7QDaN__"